import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Edit, useEditContext, useTranslate } from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Form from './detail/Form';
import Aside from './detail/Aside';

const useStyles = makeStyles({
  left: {
    width: 'calc(100% - 350px)',
  },
});

const Title = () => {
  const { record, isPending } = useEditContext();
  const translate = useTranslate();
  const name =
    !isPending && record ? record.cleaner_fullname || record.cleaner_id : null;
  const action = translate('app.page_title.edit');
  useDocumentTitle(name ? `${name} - ${action}` : action);

  return null;
};

const LeaveEdit = (props) => {
  const classes = useStyles();

  return (
    <Edit {...props} className={classes.left} title={<Title />}>
      <Form aside={<Aside />} />
    </Edit>
  );
};

export default LeaveEdit;
